import React from "react";

import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { OfferStore } from "@state/context/offer/OfferContext";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { observer } from "mobx-react";

import TeamLineups from "./TeamLineups";

export const TeamLineupsSection = observer(function TeamLineupsSection() {
	const store = useOfferContext<OfferStore.EventViewStore>();

	if (store.displayStatisticsGroup === StatisticsGroups.TeamLineups) {
		return (
			<ErrorBoundaryWithPropagation componentName="Mobile/TeamLineups.tsx">
				<TeamLineups store={store.teamLineupsStore} />
			</ErrorBoundaryWithPropagation>
		);
	}
	return null;
});
